import { State } from '../State';

export function convertUTCToClientTime(utcTime: number, state: State): number {
  return utcTime - state.timezoneOffsetMs;
}
